import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { PhoneNumberAudit } from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-phone-number-audit-list',
  templateUrl: './phone-number-audit-list.component.html',
  styleUrls: ['./phone-number-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneNumberAuditListComponent implements OnInit {
  @Input() phoneNumberId: number;
  @Input() loading: boolean;
  @Input() phoneNumberAudits: PhoneNumberAudit[];

  @Output() loadPhoneNumber = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPhoneNumber.emit(this.phoneNumberId);
  }

  onNextPage() {
    this.nextPage.emit(this.phoneNumberId);
  }
}
